export const styles = {
  header: { padding: '0 50px' },
  description: { padding: '0 50px 30px' },
  tableWrapper: {
    padding: '50px 0',
    backgroundColor: '#fff',
    '& .SearchAndFilters': {
      marginLeft: '50px',
    },
  },
  createButton: { marginLeft: 50, width: 180 },
  actionButtons: {
    display: 'flex',
  },
  pagination: {
    padding: '0 50px',
  },
}
